import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "faceRecognition"
const FaceRecognitionIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M3.75 20.25H8.25V21.75H3.75C2.922 21.75 2.25 21.078 2.25 20.25V15.75H3.75zM21.75 20.25C21.75 21.078 21.078 21.75 20.25 21.75H15.75V20.25H20.25V15.75H21.75z" />
          <path
            fillRule="evenodd"
            d="M15.388 13.85C15.156 14.567 14.703 15.19 14.095 15.633 13.486 16.074 12.753 16.312 12 16.312S10.515 16.075 9.907 15.633C9.298 15.19 8.845 14.566 8.613 13.851L8.373 13.115H15.628zM10.073 14.24Q10.284 14.515 10.567 14.722C10.984 15.025 11.487 15.188 12.001 15.188S13.017 15.025 13.433 14.722C13.622 14.586 13.787 14.422 13.928 14.24z"
            clipRule="evenodd"
          />
          <path d="M9.188 9.75C9.705 9.75 10.125 10.17 10.125 10.688 10.125 11.205 9.705 11.625 9.188 11.625S8.25 11.205 8.25 10.688 8.67 9.75 9.188 9.75M14.813 9.75C15.33 9.75 15.75 10.17 15.75 10.688 15.75 11.205 15.33 11.625 14.813 11.625S13.875 11.205 13.875 10.688 14.295 9.75 14.813 9.75" />
          <path
            fillRule="evenodd"
            d="M12 4.5C16.142 4.5 19.5 7.858 19.5 12S16.142 19.5 12 19.5 4.5 16.142 4.5 12 7.858 4.5 12 4.5M12 6C8.686 6 6 8.686 6 12S8.686 18 12 18 18 15.314 18 12 15.314 6 12 6"
            clipRule="evenodd"
          />
          <path d="M8.25 3.75H3.75V8.25H2.25V3.75C2.25 2.922 2.922 2.25 3.75 2.25H8.25zM20.25 2.25C21.078 2.25 21.75 2.922 21.75 3.75V8.25H20.25V3.75H15.75V2.25z" />
        </svg>
      }
    </span>
  )
}
export default FaceRecognitionIcon
